module.exports = __webpack_public_path__ + "static/img/wealth_level_92.48c5999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_92.png
// module id = nwGC
// module chunks = 0